module.exports = __webpack_public_path__ + "static/media/throphy-icon.fb7bb4ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/throphy-icon.svg
// module id = 778
// module chunks = 0